export default __webpack_public_path__ + "static/media/B-Kamhanda.60de1722.jpg";